import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Tabs {
    constructor() {
    }

    init() {
        this.bindEvents();
        this.setup();
    }

    openTab(href, id, clickElement) {
        const tab = $(`.js-tabs-pagebuilder .nav-tabs .nav-link${href}-tab`);
        const otherTabs = $(`#${id} .nav-tabs .nav-link`).not($(tab));
        const pane = $(href);
        const otherPanes = $(`#${id} .tab-pane`).not(pane);

        $(otherTabs).removeClass('active'); //de-active other tabs
        $(tab).addClass('active'); // activate tab

        $(otherPanes).removeClass('active').hide(); // hide other panes
        $(pane).addClass('active'); // display pane

        if (Util.getViewPort() === CONST.ViewPort.Desktop) {
            $(pane).show();
            $(tab).focus();
        }
        else if (clickElement) {
            $(`#${id} .nav-link`).not($(clickElement)).not(tab).removeClass('active');
            $(`#${id} .tab-pane`).not($(`${href}`)).slideUp();
            $(`${href}`).slideToggle('slow', (e) => {
                if ($(clickElement).hasClass('active')) {
                    $(clickElement).removeClass('active');
                }
                else {
                    $(clickElement).addClass('active');
                }
            });
        }
    }

    bindEvents() {
        $('.js-tabs-pagebuilder .nav-link').on('click', (e) => {
            e.preventDefault();
            let target = e.currentTarget;
            const id = target.closest('div.js-tabs-pagebuilder').getAttribute('id');
            const href = target.getAttribute('href');
            this.openTab(href, id, target);
        });

        // jump to tabs if hash exists for one
        if (window.location.hash) {
            const tabEl = $(`${window.location.hash}.tab-pane`);
            if ($(tabEl).length) {
                $(document).ready(() => {
                    // open mobile tab section
                    let target = null;
                    if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
                        target = $(`${window.location.hash}-tab-panel`);
                    }
                    this.openTab(window.location.hash, target);
                });
            }
        }
    }

    setup() {
        if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
            $('.js-tabs-pagebuilder .nav-link').removeClass('active');
            $('.js-tabs-pagebuilder .tab-pane').removeClass('active');
            $('.js-tabs-pagebuilder .tab-pane').hide();
        }
    }
}

export default Tabs;